/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { object, Schema, string } from '../schema';

export interface ProprietaryBankTransactionCode {
  code: string;
  issuer: string;
}

export const proprietaryBankTransactionCodeSchema: Schema<ProprietaryBankTransactionCode> = object(
  { code: ['Code', string()], issuer: ['Issuer', string()] }
);
